import { TypographyProps } from '@mui/material';
import React from 'react';
import { SubtitleSmallBoldStyled, SubtitleSmallStyled } from 'v3/shared/typography/SubtitleSmall/styles';

export const SubtitleSmall: React.FC<TypographyProps> = (props) => {
  return (
    <SubtitleSmallStyled variant="body1" {...props}>
      {props.children}
    </SubtitleSmallStyled>
  );
};

export const SubtitleSmallBold: React.FC<TypographyProps> = (props) => {
  return (
    <SubtitleSmallBoldStyled variant="body1" {...props}>
      {props.children}
    </SubtitleSmallBoldStyled>
  );
};
